export var handleMouseDown = function(onContinue) {
    return function(event) {
        if (event.button === 0) {
            event.preventDefault();
            onContinue();
        }
    };
};
